/**
 *
 * @typedef {Object} QuickViewItem
 * @property {string} id
 * @property {string} description
 * @property {string} name
 * @property {string} title
 * @property {string} subtitle
 * @property {string} imageUrl
 */

import { getIdCode } from './interaction-studio-functions';

/**
 * Regresa un objeto que corresponde a evento de QUICK VIEW ITEM de IS
 * @param {string} id
 * @param {string} description
 * @param {string} name
 * @param {string} title
 * @param {string} subtitle
 * @param {string} imageUrl
 * @param {string} locale
 * @returns {QuickViewItem}
 */
function quickViewItemObj(id, description, name, title, subtitle, imageUrl, locale) {
  return {
    id,
    description,
    name,
    title,
    subtitle,
    imageUrl,
    locale,
  };
}

/**
 * Retorna el estilo background para colocar como estilo en linea
 * @param {String} imageUrl
 * @returns {object} objeto con el estilo backgroundImage
 */
function getBackgroundInteracionStudio(imageUrl) {
  return imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};
}

/**
 * Retorna la data de un ancillary, si no encuentra regresa undefined
 * @param {Array} ancillariesIs
 * @param {string} typeAncillary
 */
function getAncillaryIs(ancillariesIs, typeAncillary) {
  let ancillaryIs = false;
  if (ancillariesIs) {
    ancillaryIs = ancillariesIs.find(ancillary => ancillary.id === typeAncillary);
  }
  return ancillaryIs;
}

/**
 * Ordena los ancillaries de acuerdo a IS
 * @param {object[]} ancillariesIS Es un array con los ancillaries entregados por Interaction Studio
 * @param {string[]} typeNamesAncillaries Es un array de objetos con los nombres de los ancillaries entregados por el cms
 * @returns {string[]} Array con los nombres de los Ancillaries
 */
function getSortIS(ancillariesIS, typeNamesAncillaries, deviceSize) {
  const isFlag = ancillariesIS && typeNamesAncillaries;
  const idAncillaries = { 'PI': 'AMS', '029': 'CBX' };
  const idAncillariesIS = ['PI', '029'];

  const sortIS = isFlag ?
    ancillariesIS.map(ancillary => {
      const idProduct = ancillary.id.split('-')[0];
      const idAncillary = idAncillariesIS.includes(idProduct) ? idAncillaries[idProduct] : idProduct;
      if (typeNamesAncillaries[idAncillary]) {
        return idAncillary;
      }
    }).filter(data => data !== undefined) : [];
  if (!typeNamesAncillaries['AMS'] && deviceSize !== 'small' && sortIS.length > 0) {
    sortIS.splice(1, 0, 'AMS');
  }

  const arrayTypes = new Set([...sortIS, ...Object.keys(typeNamesAncillaries)]);
  return Array.from(arrayTypes);
}
/**
 * Forma un objeto con las etiquetas data tag para el contenedor padre de los ancillaries
 * @param {object} dataInteractionStudio objeto que contiene la data de interacion studio
 * @returns {object} un objeto con los data tag de la campaña
 */
function getDataTagParentInteractionStudio(dataInteractionStudio) {
  const { experience, userGroup, campaign } = dataInteractionStudio;
  return {
    'data-evg-campaign-id': campaign,
    'data-evg-experience-id': experience,
    'data-evg-user-group': userGroup,
  };
}

function getDataTagChildInteractionStudio(typeAncillary) {
  return {
    'data-evg-item-id': typeAncillary,
    'data-evg-item-type': 'Product',
  };
}

/**
 * Transforma el storefront a las especificaciones de IS
 * @param {string} locate
 */
function getLocationIso(locale) {
  const exp = new RegExp('-|_', 'g');
  const arrayLocate = locale?.split(exp);
  if (locale) {
    arrayLocate[1] = arrayLocate[1]?.toUpperCase();
  }
  return locale ? arrayLocate.join('_') : '';
}
/**
 * Remplaza los caracteres con acentos
 * @param {string} text
 * @returns {string}
 */
function replaceAccents(text) {
  return text ? text.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '';
}

/**
 * Obtiene una clase y la selecciona en el Dom, regresando la ruta relativa donde se encuentra la imágen de fondo
 * @param {string} classAncillary
 * @returns {string}
 */
function getUrlBackgroundImgInteractionStudio(classAncillary) {
  const nodeAncillary = document.querySelector(`.${classAncillary}`);
  const imageUrl = nodeAncillary ? getComputedStyle(nodeAncillary).getPropertyValue('background-image') : '';
  const regExp = new RegExp(/url\(|\)|\"/, 'g');
  return imageUrl.includes('base64') ? '' : imageUrl.replace(regExp, '');
}

/**
 *
 * @param {string} experienceId //id de la experiencia de la campaña de IS
 * @param {boolean} control
 * @param {string} type
 * @param {Object} extraProperties
 */
function campaignInteractionStudio(experienceId, control, type, extraProperties = {}) {
  const stat = {
    experienceId,
    control,
    stat: type,
    ...extraProperties,
  };
  window.Evergage.sendStat({ campaignStats: [stat] });
}

/**
 * Obtiene las imágenes que contiene los ancillaries en MYB y serán ingresas a  IS a través del evento Quick View Item
 */

const imageAncillaryForIS = {
  'DPM': getUrlImage(require('../../images/img_anc_desktop/discount.png')),
  'DPI': getUrlImage(require('../../images/img_anc_desktop/discount.png')),
  'AMS': getUrlImage(require('../../images/img_anc_desktop/seguroviaje.jpg')),
  'SVI': getUrlImage(require('../../images/img_anc_desktop/seguroviaje.jpg')),
  'CO2': getUrlImage(require('../../images/img_anc_desktop/vuelaverde.jpg')),
  'CO2_2': getUrlImage(require('../../images/img_anc_desktop/vuelaverde2.jpg')),
  'AMK': getUrlImage(require('../../images/img_anc_desktop/concierge.png')),
  'CBX': getUrlImage(require('../../images/img_anc_desktop/cbx.jpg')),
  'PI': getUrlImage(require('../../images/img_anc_desktop/bg-personal-insurance.jpg')),
  'PRI': getUrlImage(require('../../images/priorityBoardingModalTotem.png')),
};

function getUrlImage(urlImg) {
  const url = urlImg?.split('/')?.filter(element => element !== '.' && element !== '')?.join('/');
  const location = window.location;
  const typeLocation = location.hostname;
  const arrayUrl = location.pathname.split('/');
  return typeLocation === 'localhost' ? `${location.origin}/${url}` : `${location.origin}/${arrayUrl[1]}/${arrayUrl[2]}/${url}`;
}

class PurchaseEventIS {
  constructor() {
    this.idArray = new Set();
    this.priceArray = [];
    // this.quantityArray = [];
    this.product = [];
    this.lineItems = [];
  }

  addProductID(id) {
    this.idArray.add(getIdCode(id));
  }

  addProductPrice(price) {
    this.priceArray.push(price);
  }

  addProductQuantity(quantity) {
    this.quantityArray.push(quantity);
  }

  addProduct(product) {
    product.id = getIdCode(product.id);
    this.product.push(product);
  }

  addSeatLineItems(data) {
    this.lineItems.push({
      _id: data?._id,
      price: data?.price,
      quantity: data?.quantity,
    });
    return {
      lineItems: this.lineItems,
      currency: data?.currency,
      totalValue: data?.totalValue,
    };
  }

  createPurcheseEvent() {
    const idArray = Array.from(this.idArray);
    idArray.forEach(currentId => {
      const typeProduct = this.product.filter(currentProduct => currentProduct.id === currentId);
      const priceProduct = typeProduct.reduce((previus, current) => previus + current.price, 0);
      const quantity = typeProduct.length;
      const flagSummation = currentId === 'BAG' || currentId === 'PI';
      const priceByProduct = flagSummation ? parseFloat((priceProduct / quantity).toFixed(2)) : typeProduct[0].price;
      // this.addProductQuantity(typeProduct.length);
      this.addProductPrice(priceProduct);
      this.lineItems.push({
        _id: currentId,
        quantity,
        price: priceByProduct,
      });
    });
  }

  getObjectPurchaseEvent(currencyCode) {
    this.createPurcheseEvent();
    return {
      lineItems: this.lineItems,
      totalValue: this.priceArray.reduce((previus, current) => previus + current, 0),
      currency: currencyCode,
    };
  }
}
/**
 * Envio del evento de traking impresion de interaction studio que se detona cuanto se pintan los productos en la vista
 * @param {string} experienceId //id de la experiencia en de la campaña
 * @param {string[]} idProducts // array con los id de los productos que se estan viendo
 * @param {boolean} control
 */
function trakingCampaintImpression(experienceId, idProducts = [], control = false) {
  const campaignControl = Boolean(control);
  const stat = {
    experienceId,
    stat: 'Impression',
    control: campaignControl,
    catalog: {
      Product: idProducts || [],
    },
  };

  if (window?.Evergage && !campaignControl) {
    window.Evergage.sendStat({ campaignStats: [stat] });
  }
}

/**
 * Envio del evento de traking click de interaction studio que se activa cuando se le da click a un producto
 * @param {string} experienceId //id de la experiencia en de la campaña
 * @param {string} idProduct // id del producto al que se le dio click
 * @param {boolean} control
 */
function trakingCampaintClick(experienceId, idProduct = '', control = false, activeAncillaryCampaign = []) {
  const campaignControl = Boolean(control);
  const stat = {
    experienceId,
    stat: 'Clickthrough',
    control: campaignControl,
    ...(idProduct === null || idProduct === undefined ? {} : {
      catalog: {
        Product: [getIdCode(idProduct)],
      },
    }),
  };

  if (window?.Evergage && experienceId !== undefined && activeAncillaryCampaign.includes(getIdCode(idProduct))) {
    window.Evergage.sendStat({ campaignStats: [stat] });
  }
}

function getTypeUserGroupMC(userGroup) {
  const typeCampaignMC = { 'Control': 'IS_CU_4C' };
  return userGroup ? typeCampaignMC[userGroup] || 'IS_CU_4' : null;
}

function getActiveinteractionStudio(productIS = [], activeProduct = {}) {
  const idProductsIS = productIS?.map(ancillary => ancillary?.id);
  const activeProducts = idProductsIS?.filter(data => {
    const idProducts = {
      'PI': 'AMS',
      '029': 'CBX',
    };
    const idProduct = idProducts[data] || data;
    return Boolean(activeProduct[idProduct]);
  });

  return activeProducts;
}

/**
 *
 * @param {string} idUser
 * @param {string} pnr
 * @param {string} language
 * @param {string} storeFront
 * @param {string} origin
 * @param {string} description
 * @param {string} locale
 * @returns 
 */
function ancillaryRejectObj(user = '', lastViewAncillary = '', pnr = '', language = '', storeFront = '', locale, route = [], firstName, lastName) {
  const routeFlights = route && route[0];
  const dataUser = window?.Evergage?.getCurrentPage();
  const anonId = dataUser?.user?.anonId;
  const userObj = user ? { id: user } : { anonId };
  return {
    action: 'AncillaryRejected',
    flags: {
      noCampaigns: true,
    },
    source: {
      channel: 'Server',
      application: 'Web',
      locale: getLocationIso(locale),
    },
    user: {
      ...userObj,
      attributes: {
        PNR: pnr,
        language,
        storeFront,
        origin: routeFlights?.departureAirport,
        destination: routeFlights?.arrivalAirport,
        emailAddress: user,
        apellidoEmail: lastName,
        nombreEmail: firstName,
        ancillary: lastViewAncillary,
      },
    },
  };
}

export const getEnviroment = () => {
  const env = location.hostname;
  const isBetaProd = /^((www|beta|alpha).)*(aeromexico)\.com$/gi.test(env);

  return isBetaProd;
};

function getHeaderMarketingCloud(token, key, envUrl) {
  try {
    const tokenSecret = JSON.parse(atob(token));
    const keySecret = JSON.parse(atob(key));
    const envSecret = JSON.parse(atob(envUrl));
    const optionHeader = getEnviroment() ? 'prod' : 'cert';
    return {
      tokenSecret: tokenSecret[optionHeader] || '',
      keySecret: keySecret[optionHeader] || '',
      envSecret: envSecret[optionHeader] || '',
    };
  } catch (error) {
    return {
      tokenSecret: '',
      keySecret: '',
      envSecret: '',
    };
  }
}


export {
  ancillaryRejectObj,
  campaignInteractionStudio,
  getActiveinteractionStudio,
  getAncillaryIs,
  getBackgroundInteracionStudio,
  getDataTagChildInteractionStudio,
  getDataTagParentInteractionStudio,
  getHeaderMarketingCloud,
  getLocationIso,
  getSortIS,
  getTypeUserGroupMC,
  getUrlBackgroundImgInteractionStudio,
  getUrlImage,
  imageAncillaryForIS,
  PurchaseEventIS,
  quickViewItemObj,
  replaceAccents,
  trakingCampaintClick,
  trakingCampaintImpression,
};